import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/v2/badge";
import { Button } from "@/components/ui/v2/button";

export type ActiveFilter = {
  key: string;
  label: string;
  value: string | number;
  valueLabel: string;
};

type TableActiveFiltersProps = {
  filters: ActiveFilter[];
  onRemoveFilter: (filter: ActiveFilter) => void;
  onClearFilters: () => void;
};

export function TableActiveFilters({
  filters,
  onRemoveFilter,
  onClearFilters,
}: TableActiveFiltersProps) {
  const { t } = useTranslation();

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-nowrap items-center gap-2 overflow-x-auto overflow-y-hidden pb-2">
      {filters.map((filter) => (
        <Badge
          key={`${filter.key}-${filter.value}`}
          variant="outline"
          size="medium"
          className="group flex-shrink-0 gap-1.5 font-normal hover-tint-primary"
        >
          <span className="text-xs font-medium text-muted-foreground">
            {filter.label}
          </span>
          <span className="text-xs text-foreground">{filter.valueLabel}</span>
          <Button
            type="button"
            variant="ghost"
            size="icon-xs"
            onClick={() => onRemoveFilter(filter)}
            aria-label={`Remove ${filter.label} filter`}
            className="[&>svg]:pointer-events-auto"
          >
            <X className="size-3" />
          </Button>
        </Badge>
      ))}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onClearFilters}
        className="h-7 flex-shrink-0 text-xs text-muted-foreground hover:text-foreground"
      >
        {t("buttons.resetFilters")}
      </Button>
    </div>
  );
}
